var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content",attrs:{"slot":"content","id":"content","role":"main"},slot:"content"},[_c('Header'),_c('Menu'),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }